import React, { createContext, useState, useContext, useEffect } from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';
import axios from 'axios';
import { API } from '../config';

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadStoredUser();
    }, []);

    const loadStoredUser = async () => {
        try {
            const stored = await AsyncStorage.getItem('user');
            if (stored) {
                setUser(JSON.parse(stored));
            }
        } catch (error) {
            console.error('Error loading user:', error);
        } finally {
            setLoading(false);
        }
    };

    const login = async (telepon, password) => {
        try {
            console.log('Attempting login to:', API.AUTH.LOGIN);
            const response = await axios.post(API.AUTH.LOGIN, {
                telepon,
                password,
            }, { timeout: 10000 });

            if (response.data.success) {
                const userData = response.data.data.member;
                userData.token = response.data.data.token;

                await AsyncStorage.setItem('user', JSON.stringify(userData));
                setUser(userData);

                return { success: true };
            } else {
                return { success: false, message: response.data.message };
            }
        } catch (error) {
            console.error('Login error:', error);
            let errorMsg = 'Gagal terhubung ke server';
            if (error.code === 'ECONNABORTED') {
                errorMsg = 'Timeout - server tidak merespon';
            } else if (error.message) {
                errorMsg = error.message;
            }
            return { success: false, message: errorMsg };
        }
    };

    const register = async (nama, telepon, email, password) => {
        try {
            const response = await axios.post(API.AUTH.REGISTER, {
                nama,
                telepon,
                email,
                password,
            });

            return {
                success: response.data.success,
                message: response.data.message,
            };
        } catch (error) {
            console.error('Register error:', error);
            return { success: false, message: 'Gagal terhubung ke server' };
        }
    };

    const logout = async () => {
        try {
            await AsyncStorage.removeItem('user');
            setUser(null);
        } catch (error) {
            console.error('Logout error:', error);
        }
    };

    const refreshUser = async () => {
        if (!user) return;

        try {
            const response = await axios.get(API.MEMBER.PROFILE(user.id));
            if (response.data.success) {
                const updatedUser = { ...user, ...response.data.data };
                await AsyncStorage.setItem('user', JSON.stringify(updatedUser));
                setUser(updatedUser);
            }
        } catch (error) {
            console.error('Refresh user error:', error);
        }
    };

    return (
        <AuthContext.Provider
            value={{
                user,
                loading,
                login,
                register,
                logout,
                refreshUser,
                isLoggedIn: !!user,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
